module.exports = __webpack_public_path__ + "static/media/logo_leibniz_de.97d5c5df.svg";